<template>
    <p class="text-xs text-theme-muted text-center">
        {{ text }}
    </p>
</template>

<script>
import { IMAGE_RIGHTS_NOTICE } from "@/common/fields/legal-documents";

export default {
    name: "ImageRightsNotice",
    data: () => ({
        text: IMAGE_RIGHTS_NOTICE
    })
};
</script>
